var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wgu-app-tpl',[(_vm.inIframe())?_c('base',{attrs:{"target":"_parent"}}):_vm._e(),_vm._v(" "),_c('PoiInfo',{attrs:{"slot":"wgu-before-content","color":_vm.baseColor},slot:"wgu-before-content",scopedSlots:_vm._u([{key:"poiinfo-after-subtitle",fn:function(slotProps){return [(slotProps.featureProperties)?_c('v-sparkline',{attrs:{"value":_vm.extractTimeLineValues(slotProps.featureProperties.series),"color":_vm.baseColor}}):_vm._e()]}}])})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c809b244","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/WguApp.vue
// module id = C22J
// module chunks = 1